import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    render() {
        return (
            <radio-group>
                <label>
                    <pseudo-radio
                        className={`${this.props.checked ? 'checked ' : ''}${this.props.disabled ? 'disabled' : ''}`}
                    >
                        <span />
                        <input type='radio' {...this.props} />
                    </pseudo-radio>
                    <span dangerouslySetInnerHTML={{__html: this.props.label}} />
                </label>
            </radio-group>
        );
    }
}

export default connect()(Component);